module.exports = __webpack_public_path__ + "static/LogoFooter-425eff957301badd73bc7e81962c0e78.png";